// routes.js

import Error404 from "../views/Error404";
import CreateSurvey from "../views/CreateSurvey";
import Surveys from "../views/Surveys";
import EditSurvey from "../views/EditSurvey";
import Layouts from "../views/Layouts";
import CreateLayout from "../views/CreateLayout";
import EditLayout from "../views/EditLayout";
import Report from "../views/Report";


const routes = [
    {
        path: '/',
        redirect: '/surveys'
    }
    ,
    {
        path: '/survey/create',
        name: 'createsurvey',
        component: CreateSurvey
    },
    {
        path: '/survey/:id/edit',
        name: 'editsurvey',
        component: EditSurvey
    },
    {
        path: '/survey/:id/report',
        name: 'report',
        component: Report
    },
    {
        path: '/surveys',
        name: 'surveys',
        component: Surveys
    },
    {
        path: '/layouts',
        name: 'layouts',
        component: Layouts
    },
    {
        path: '/layout/create',
        name: 'createlayout',
        component: CreateLayout
    },
    {
        path: '/layout/:id/edit',
        name: 'editlayout',
        component: EditLayout
    },
    {
        path: '*',
        component: Error404
    }
];

export default routes;